import { FamilyPlanOptions, Addons } from '../locale';
import { toCurrency, roundTo } from '../utils';

export const calculateFamilyPlanCost = (addons: Addons, selectedFamilyPlanAddons: FamilyPlanOptions) => {
  return toCurrency(
    selectedFamilyPlanAddons.adults * addons.adults.price +
      selectedFamilyPlanAddons.children * addons.children.price +
      selectedFamilyPlanAddons.pets * addons.pets.price,
  );
};

export const calculateFamilyPlanCarbon = (addons: Addons, selectedFamilyPlanAddons: FamilyPlanOptions) => {
  return roundTo(2)(
    (selectedFamilyPlanAddons.adults * addons.adults.stats.carbon +
      selectedFamilyPlanAddons.children * addons.children.stats.carbon +
      selectedFamilyPlanAddons.pets * addons.pets.stats.carbon) *
      12,
  );
};

export const calculateFamilyPlanAnnualCarbon = (addons: Addons, selectedFamilyPlanAddons: FamilyPlanOptions) => {
  const adultsTotal =
    selectedFamilyPlanAddons.adults * (addons.adults.stats.carbonAnnual || addons.adult.stats.carbon * 12);

  const childrenTotal =
    selectedFamilyPlanAddons.children * (addons.children.stats.carbonAnnual || addons.children.stats.carbon * 12);

  const petsTotal = selectedFamilyPlanAddons.pets * (addons.pets.stats.carbonAnnual || addons.pets.stats.carbon * 12);

  return roundTo(2)(adultsTotal + childrenTotal + petsTotal);
};

export const calculateFamilyPlanTrees = (addons: Addons, selectedFamilyPlanAddons: FamilyPlanOptions) => {
  return roundTo(2)(
    selectedFamilyPlanAddons.adults * addons.adults.stats.trees +
      selectedFamilyPlanAddons.children * addons.children.stats.trees +
      selectedFamilyPlanAddons.pets * addons.pets.stats.trees,
  );
};

export const calculateFamilyPlanTotals = (addons: Addons, selectedFamilyPlanAddons: FamilyPlanOptions) => {
  return {
    price: calculateFamilyPlanCost(addons, selectedFamilyPlanAddons),
    carbon: calculateFamilyPlanCarbon(addons, selectedFamilyPlanAddons),
    carbonAnnual: calculateFamilyPlanAnnualCarbon(addons, selectedFamilyPlanAddons),
    trees: calculateFamilyPlanTrees(addons, selectedFamilyPlanAddons),
  };
};
